module.exports = __webpack_public_path__ + "static/assets/8c0c02f16572b730d422f96a3ce53e7f.mp3";